export const folderDisplayName = "b9Epud";
export default {folderDisplayName};